module.exports = __webpack_public_path__ + "img/whereby.403917f1.png";